/**
 * Routes where the floating assessment lead CTA replaces the Order Request
 * cart button.
 *
 * These pages sell the Fleet Preservation Program rather than any orderable
 * product — there is nothing on them to add to a request list, so the cart
 * button has nothing to collect. The goal on these pages is a lead we can call
 * back to scope an assessment, so the assessment form takes the slot instead.
 *
 * Both buttons float in the same bottom-right position, so exactly one of them
 * may render on a given route. Anything already in the request list is kept in
 * localStorage and the cart button returns on every other page.
 */
const LEAD_CTA_ROUTES = [
  "/fleet-asset-protection",
  "/fleet-preservation-process",
  "/protect-your-fleet-from-corrosion-downtime",
  "/touchless-drive-thru",
];

export function showsLeadCta(pathname: string): boolean {
  if (pathname === "/" || pathname === "") return true;
  return LEAD_CTA_ROUTES.some((r) => pathname.startsWith(r));
}
